import { MinusCircleIcon, PlusCircleIcon } from "@heroicons/react/24/outline";

const buildTenantTree: (departments: any) => never[] = (departments) => {
  const sortedDepartments: any = departments.sort((a, b) =>
    a.display_order.localeCompare(b.display_order),
  );

  const map = {};
  const roots = [];

  sortedDepartments.forEach((dept) => {
    map[dept.id] = { ...dept, children: [] };
  });

  sortedDepartments.forEach((dept) => {
    if (dept.parent === null) {
      roots.push(map[dept.id]);
    } else {
      if (map[dept.parent]) {
        map[dept.parent].children.push(map[dept.id]);
      }
    }
  });

  const sortChildren = (nodes) => {
    nodes.forEach((node) => {
      if (node.children.length > 0) {
        node.children.sort((a, b) =>
          a.display_order.localeCompare(b.display_order),
        );
        sortChildren(node.children);
      }
    });
  };

  sortChildren(roots);

  return roots;
};

export const DepartmentTree = ({
  depts,
  setSelectedDepartments,
  expandedNodes,
  toggleExpand,
  handleOpenChangeParentModal,
  handleOpenDeleteModal,
  handleOpenCreatePage,
  handleOpenEditPage,
}) => {
  const handleUpdateSelectedDepartments = (
    nodeId: number,
    isSelected: boolean,
  ) => {
    setSelectedDepartments((prevSelected) => {
      if (prevSelected.includes(nodeId)) {
        return prevSelected.filter((id) => id !== nodeId);
      } else {
        return [...prevSelected, nodeId];
      }
    });
  };

  const displayTree = (nodes) => {
    return (
      <ul>
        {nodes.map((node) => (
          <li key={node.id} className="ml-2">
            <div className="flex justify-between items-center gap-2">
              <input
                type="checkbox"
                className="fixed"
                onChange={(e) => {
                  if (e.target.checked) {
                    handleUpdateSelectedDepartments(node.id, true);
                  } else {
                    handleUpdateSelectedDepartments(node.id, false);
                  }
                }}
              />
              {node?.children?.length >= 1 ? (
                <div
                  className="flex justify-normal items-center whitespace-nowrap"
                  onClick={() => toggleExpand(node.id)}
                >
                  {expandedNodes[node.id] ? (
                    <MinusCircleIcon className="ml-10 mr-5 w-5 h-5 text-mayo-link-text hover:opacity-50" />
                  ) : (
                    <PlusCircleIcon className="ml-10 mr-5 w-5 h-5 text-mayo-link-text hover:opacity-50" />
                  )}
                  <div className="underline hover:opacity-50 cursor-pointer label-light-blue-xl">
                    [{node.display_order}] {node.name}
                  </div>
                </div>
              ) : (
                <div className="flex justify-normal items-center">
                  <div className="mr-5 w-5 h-5" />
                  <div className="label-light-blue-xl">
                    [{node.display_order}] {node.name}
                  </div>
                </div>
              )}

              <div className="flex flex-col sm:flex-row sm:items-center sm:ml-0 ml-4 gap-2 sm:gap-2">
                {node.parent != null && (
                  <button
                    className="button-small-white"
                    onClick={() => handleOpenChangeParentModal(node.id)}
                  >
                    親部署を変更
                  </button>
                )}

                <button
                  type="button"
                  className="button-small-red"
                  onClick={() => handleOpenDeleteModal(node.id)}
                >
                  削除
                </button>

                <button
                  className="button-small-white"
                  onClick={() => handleOpenCreatePage(node.id)}
                >
                  階層を追加
                </button>

                <button
                  className="button-confirm font-normal"
                  onClick={() => handleOpenEditPage(node.id)}
                >
                  編集
                </button>
              </div>
            </div>
            <div className="divider mt-2"></div>
            {node.children &&
              node.children.length > 0 &&
              expandedNodes[node.id] && (
                <div className="ml-10 mt-2">{displayTree(node.children)}</div>
              )}
          </li>
        ))}
      </ul>
    );
  };

  return <div>{displayTree(depts)}</div>;
};
